import { z } from "zod";
import { isoAndUnixZodSchema, nowIsoAndUnix } from "../date-time/iso-and-unix";
import { productIdZodSchema } from "../products/product-id";
import { providerIdZodSchema } from "../providers/provider-id";
import { productFormFieldZodUnion } from "./fields/product-form-field";
import type { ProductFormId } from "./product-form-id";
import {
    productFormIdFactory,
    productFormIdZodSchema,
} from "./product-form-id";

const productFormZodObject = z.object({
    _id: productFormIdZodSchema,
    _type: z.literal("PRODUCT_FORM"),
    _createdAt: isoAndUnixZodSchema,
    // title: translatableZodSchema,
    // description: translatableZodSchema.optional(),
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
    fields: z.array(productFormFieldZodUnion),
});

type ProductForm = z.infer<typeof productFormZodObject>;

const factoryParamsZodObject = productFormZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});

type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormFactory = (
    params: FactoryParams & {
        _id?: ProductFormId;
    },
): ProductForm => {
    return {
        ...params,
        _id: params._id ?? productFormIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "PRODUCT_FORM",
    };
};

export {
    productFormFactory,
    factoryParamsZodObject as productFormFactoryParamsZodObject,
    productFormZodObject,
};
export type { ProductForm };
